@if (crossAssessmentsLoaded) {
  @if (crossAssessments.length > 0) {
    <div class="box-comment">
      @for (assessment of crossAssessments; track assessment.id) {
        @switch (assessment !== edittingReviewAssessment) {
          @case (true) {
            <app-cross-assessment-item
              [crossAssessment]="assessment"
              [canRequestReview]="canRequestReview(assessment)"
              (requestReviewAssessment)="onRequestReviewAssessment(assessment)"
            >
            </app-cross-assessment-item>
          }
          @case (false) {
            <app-request-review-assessment
              [crossAssessment]="assessment"
              (cancelEditAssessment)="cancelEditAssessment()"
              (updateOldAssessment)="onUpdateOldAssessment($event, assessment)"
            >
            </app-request-review-assessment>
          }
        }
      }
    </div>
  } @else {
    <div class="empty-content">
      <p>ここに相互評価のコメントが表示されます。</p>
    </div>
  }
  @if (canLoadMore) {
    <div class="load-more">
      <a class="spen-util-link" (click)="loadMoreCrossAssessments()">
        <span>もっと見る</span>
        <i [class]="isLoadingMore ? 'fa fa-spinner fa-spin' : 'fa fa-chevron-down'"></i>
      </a>
    </div>
  }
} @else {
  <div class="spen-mod-flex-loading"><div class="loading-icon"></div></div>
}
